import { fetchOrchidAPI } from "utils/api";
import { getErrorDetail } from "components/utility/utils.js";

export default async function switchToMinor(
  orchidProUserId: string,
  minorUserId: string,
) {
  const res = await fetchOrchidAPI(
    `/api/users/v1/minors/switch/${orchidProUserId}/${minorUserId}`,
    {
      method: "POST",
    },
  );
  if (!res.ok) {
    throw new Error(
      `failed to switch to minor: ${getErrorDetail(await res.text())}`,
    );
  }

  return;
}
